import {PdfDetailedUserHeaderComponent} from "./pdfDetailedUserHeaderComponent";
import {Localizer} from "../../../../infrastructure/localization/localizer";
import PdfHeaderRow from "../components/pdfHeaderRow";
import { PdfKursusHeaderModel } from "../models/pdfKursusHeaderModel";

type PdKursusHeaderComponentProps = {
    data: PdfKursusHeaderModel;
}

export function PdKursusHeaderComponent({ data }: PdKursusHeaderComponentProps) {
    return (
        <div className={"card shadow-none"}>
            <div className={"card-body flex-container-column flex-space"}>
                <PdfDetailedUserHeaderComponent bruger={data.bruger}/>
                <PdfHeaderRow>
                    <PdfHeaderRow.Entry
                        label={Localizer.global_speciale()}
                        value={data.speciale.navn}
                    />
                </PdfHeaderRow>
            </div>
        </div>
    );
}
